import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fermeture-note" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  class: "step-three-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreavisStepsBar = _resolveComponent("PreavisStepsBar")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_StepOne = _resolveComponent("StepOne")!
  const _component_StepThree = _resolveComponent("StepThree")!
  const _component_ErrorMessageFormulaire = _resolveComponent("ErrorMessageFormulaire")!
  const _component_PreavisFormCreateEdit = _resolveComponent("PreavisFormCreateEdit")!
  const _component_ModalCardConfirm = _resolveComponent("ModalCardConfirm")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.visible)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onCancel: _ctx.onCancel
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ModalCardConfirm, {
              activeValidate: _ctx.canConfirm,
              back: _ctx.goPrev,
              contentMaxHeight: _ctx.contentMaxHeight,
              first: _ctx.step === 1 || _ctx.step === _ctx.initialStep,
              headerTitle: _ctx.title,
              maxWidth: _ctx.maxWidth,
              overflowContent: _ctx.step === 3 ? 'visible' : 'auto',
              width: _ctx.width,
              onCancel: _ctx.onCancel,
              onConfirm: _ctx.onConfirm
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PreavisStepsBar, {
                  selectedEquipementsCount: _ctx.selectedEquipementIds.length,
                  step: _ctx.step
                }, null, 8, ["selectedEquipementsCount", "step"]),
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_ReglePastille, { cle: "preavisIntervention.fermetureReinitialise" })
                ]),
                _createElementVNode("div", _hoisted_2, [
                  (_ctx.step === 1)
                    ? (_openBlock(), _createBlock(_component_StepOne, {
                        key: 0,
                        title: _ctx.$t('administratif.navigation.equipements.search'),
                        "equipement-namespace": "preavisEquipementModule",
                        "site-getter": "preavisInterventionState/getPreavisSite",
                        "site-mutation": _ctx.PREAVIS_SITE_MUTATION,
                        "reset-to-step-mutation": '',
                        "set-equipement-mutation": '',
                        "site-list-namespace": "preavisSiteList",
                        style: {"max-height":"56vh"},
                        onNext: _ctx.goNext
                      }, null, 8, ["title", "site-mutation", "onNext"]))
                    : (_ctx.step === 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(_component_StepThree, {
                            selectedIds: _ctx.selectedEquipementIds,
                            "display-radio": false,
                            multiple: true,
                            "open-info-equipement": false,
                            "excluded-equipement-ids": _ctx.excludedEquipementIdsFromPreavis,
                            "allow-select-all": true,
                            "equipement-namespace": "preavisEquipementModule",
                            "site-getter": "preavisInterventionState/getPreavisSite",
                            "set-equipement-mutation": '',
                            style: {"max-height":"56vh"},
                            "onUpdate:selectedIds": _ctx.onSelectedIdsUpdate
                          }, null, 8, ["selectedIds", "excluded-equipement-ids", "onUpdate:selectedIds"]),
                          (_ctx.manuallyConflictingEquipement.length > 0)
                            ? (_openBlock(), _createBlock(_component_ErrorMessageFormulaire, {
                                key: 0,
                                items: _ctx.manuallyConflictingEquipement,
                                message: _ctx.$t('preavisIntervention.conflict.message')
                              }, null, 8, ["items", "message"]))
                            : _createCommentVNode("", true),
                          (_ctx.autoExcludedEquipement.length > 0)
                            ? (_openBlock(), _createBlock(_component_ErrorMessageFormulaire, {
                                key: 1,
                                items: _ctx.autoExcludedEquipement,
                                message: _ctx.$t('preavisIntervention.conflict.selectAll.message')
                              }, null, 8, ["items", "message"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ReglePastille, { cle: "preavisIntervention.conflitEquipement" })
                        ]))
                      : (_ctx.step === 3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(_component_ReglePastille, { cle: "preavisIntervention.objetParDefaut" }),
                            _createVNode(_component_PreavisFormCreateEdit, {
                              ref: "formulaireRef",
                              initialObjet: _ctx.initialObjet,
                              onStateChange: _ctx.onStepThreeStateChange
                            }, null, 8, ["initialObjet", "onStateChange"])
                          ]))
                        : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["activeValidate", "back", "contentMaxHeight", "first", "headerTitle", "maxWidth", "overflowContent", "width", "onCancel", "onConfirm"])
          ]),
          _: 1
        }, 8, ["onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.isSubmitting)
      ? (_openBlock(), _createBlock(_component_WaitingModal, {
          key: 1,
          text: _ctx.$t('preavisIntervention.chargement.encours')
        }, null, 8, ["text"]))
      : _createCommentVNode("", true)
  ], 64))
}